import { GetterTree } from "vuex";
import { IAddressLookupState } from "./types";
import { IRootState } from "@/store/types";

export namespace ADDRESS_LOOKUP_GETTERS {
  export const GET_PROGRESS_BY_KEY = "getProgressByKey";
  export const GET_RESULT_BY_KEY = "getResultByKey";
}

export const getters: GetterTree<IAddressLookupState, IRootState> = {
  [ADDRESS_LOOKUP_GETTERS.GET_PROGRESS_BY_KEY](
    state: IAddressLookupState,
    key: string
  ): any {
    return state.progress[key];
  },
  [ADDRESS_LOOKUP_GETTERS.GET_RESULT_BY_KEY](
    state: IAddressLookupState,
    key: string
  ): any {
    return state.responses[key];
  }
};
